// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import Crud__AccordionController from "./crud/accordion_controller"
application.register("crud--accordion", Crud__AccordionController)

import Crud__AutoSubmitController from "./crud/auto_submit_controller"
application.register("crud--auto-submit", Crud__AutoSubmitController)

import Crud__BulkActionsController from "./crud/bulk_actions_controller"
application.register("crud--bulk-actions", Crud__BulkActionsController)

import Crud__ClipboardController from "./crud/clipboard_controller"
application.register("crud--clipboard", Crud__ClipboardController)

import Crud__HasManyController from "./crud/has_many_controller"
application.register("crud--has-many", Crud__HasManyController)

import Crud__ModalController from "./crud/modal_controller"
application.register("crud--modal", Crud__ModalController)

import Crud__PasswordFieldController from "./crud/password_field_controller"
application.register("crud--password-field", Crud__PasswordFieldController)

import Crud__SearchFieldController from "./crud/search_field_controller"
application.register("crud--search-field", Crud__SearchFieldController)

import Crud__SlimSelectController from "./crud/slim_select_controller"
application.register("crud--slim-select", Crud__SlimSelectController)

import Crud__StopPropagationController from "./crud/stop_propagation_controller"
application.register("crud--stop-propagation", Crud__StopPropagationController)

import Crud__SubmitActionController from "./crud/submit_action_controller"
application.register("crud--submit-action", Crud__SubmitActionController)

import Crud__TabsController from "./crud/tabs_controller"
application.register("crud--tabs", Crud__TabsController)

import EntityListController from "./entity_list_controller"
application.register("entity-list", EntityListController)

import EntityPickerController from "./entity_picker_controller"
application.register("entity-picker", EntityPickerController)

import HoverCardController from "./hover_card_controller"
application.register("hover-card", HoverCardController)

import Cp2020__RoleController from "./cp2020/role_controller"
application.register("cp2020--role", Cp2020__RoleController)

// Skills: a collection + item pair like equipment, but with no cost, a keyed-blob
// serialize, its own stat-grouping placement, and the chargen orchestration
// (budgets/highlight/upbringing) as collection methods.
import { SkillItem, SkillsCollection } from "./cp2020/skills"
application.register("cp2020--skills", SkillsCollection)
application.register("cp2020--skills-item", SkillItem)

import Cp2020__ChildhoodEnvironmentController from "./cp2020/childhood_environment_controller"
application.register("cp2020--childhood-environment", Cp2020__ChildhoodEnvironmentController)

import Cp2020__StatBroadcastController from "./cp2020/stat_broadcast_controller"
application.register("cp2020--stat-broadcast", Cp2020__StatBroadcastController)

import Cp2020__SheetController from "./cp2020/sheet_controller"
application.register("cp2020--sheet", Cp2020__SheetController)

import Cp2020__ComputedStatsController from "./cp2020/computed_stats_controller"
application.register("cp2020--computed-stats", Cp2020__ComputedStatsController)

import Cp2020__PlayStateController from "./cp2020/play_state_controller"
application.register("cp2020--play-state", Cp2020__PlayStateController)

import Cp2020__ArmorStateController from "./cp2020/armor_state_controller"
application.register("cp2020--armor-state", Cp2020__ArmorStateController)

import Cp2020__ArmoredClothingBuilderController from "./cp2020/armored_clothing_builder_controller"
application.register("cp2020--armored-clothing-builder", Cp2020__ArmoredClothingBuilderController)

// Equipment: a per-type COLLECTION + ITEM controller pair per area, composed from
// shared Item/Collection bases (see collection_base). Each item answers for itself
// (cost/entry/…); each collection is a pure enumerator (get/getAll return items).
// Registered as cp2020--<area> (collection) + cp2020--<area>-item (item).
import { GearItem, GearCollection } from "./cp2020/gear"
import { WeaponsItem, WeaponsCollection } from "./cp2020/weapons"
import { CyberwareItem, CyberwareCollection } from "./cp2020/cyberware"
import { ArmorItem, ArmorCollection } from "./cp2020/armor"
import { ChipItem, ChipsCollection } from "./cp2020/chips"

application.register("cp2020--gear", GearCollection)
application.register("cp2020--gear-item", GearItem)
application.register("cp2020--weapons", WeaponsCollection)
application.register("cp2020--weapons-item", WeaponsItem)
application.register("cp2020--cyberware", CyberwareCollection)
application.register("cp2020--cyberware-item", CyberwareItem)
application.register("cp2020--armor", ArmorCollection)
application.register("cp2020--armor-item", ArmorItem)
application.register("cp2020--chips", ChipsCollection)
application.register("cp2020--chips-item", ChipItem)

import Cp2020__EquipmentCostsController from "./cp2020/equipment_costs_controller"
application.register("cp2020--equipment-costs", Cp2020__EquipmentCostsController)

import TurboFetchController from "./turbo_fetch_controller"
application.register("turbo-fetch", TurboFetchController)
